import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && (
        // #182 follow-up: trim the tab body's side padding on mobile — it
        // stacks on top of CardContent's own padding, and 16+16px on a narrow
        // screen was flagged as far too much horizontal margin. Vertical
        // padding is unchanged; desktop keeps the full 16px sides.
        <Box sx={{ py: 2, px: { xs: 0.5, sm: 2 } }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

export default TabPanel;
